import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DailyTripService } from "../../../services/daily-trip.service";
import { IDailyTripTicket } from "./../../../models/trips/dailyTripTicket";

@Component({
  selector: "app-daily-trip-ticket",
  templateUrl: "./daily-trip-ticket.component.html",
  styleUrls: ["./daily-trip-ticket.component.css"],
})
export class DailyTripTicketComponent implements OnInit {
  dailyTrip: IDailyTripTicket;
  error: string = "";

  constructor(
    private _dailyTripService: DailyTripService,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    let id = this._activatedRoute.snapshot.params["id"];
    if (id) {
      this._dailyTripService.getDailyTripTricket(id).subscribe((result) => {
        if (result.isSuccess) {
          this.dailyTrip = result.data;
          // setTimeout(() => {
          //   window.print();
          // }, 2000);
        } else {
          this.error = result.error;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/trips/daily-trip-ticket/daily-trip-ticket.component.ts